import './App.css';
import Home from './pages/Home';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from './pages/Acceso';
import Carrito from './pages/CarritoPage';
import PerfilPage from './pages/PerfilPage';
import PagoPage from './pages/PagoPage';
import Register from './pages/RegisterAcceso';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import CheckoutSuccessPage from './pages/CheckoutSuccessPage';
import PerfilAdminPage from './pages/PerfilAdminPage';
import CheckoutTransferenciaPage from './pages/CheckoutTransferenciaPage'; // ✅ NUEVO
import PoliticasPage from './pages/PoliticasPage';
import PreguntasPage from './pages/PreguntasPage';
import ContactoPage from './pages/ContactoPage';
import ScrollToTop from './components/ScrollToTop';
import PartnersPage from './pages/PartnersPage';
// === SEGUIMIENTO VSANA ===
import SeguimientoVsanaPage from './pages/SeguimientoVsanaPage';
// === MACROS ===
import SeguimientoMacrosPage from './pages/SeguimientoMacrosPage';
import HabitosPage from './pages/HabitosPage';



function App() {
  return (
    <Router>
         <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/carrito" element={<Carrito />} />
        <Route path="/perfil" element={<PerfilPage />} />
        <Route path="/pago" element={<PagoPage />} />
        <Route path="/register" element={<Register />} />


        <Route path="/politicas" element={<PoliticasPage />} />
        <Route path="/preguntas" element={<PreguntasPage />} />
        <Route path="/contacto" element={<ContactoPage />} />
        <Route path="/partners" element={<PartnersPage />} />
        
        
                {/* === SEGUIMIENTO VSANA === */}
        <Route path="/vsana" element={<SeguimientoVsanaPage />} />
             {/* === MACROS === */}
        <Route path="/macros" element={<SeguimientoMacrosPage />} />
        
         {/* === HÁBITOS === */}
        <Route path="/habitos" element={<HabitosPage />} />

        

    {/* Paso 1: pedir email */}
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        {/* Paso 2: formulario con uid/token */}
        <Route path="/reset-password/:uid/:token" element={<ResetPasswordPage />} />

        <Route path="/checkout-transferencia" element={<CheckoutTransferenciaPage />} /> {/* ✅ NUEVO */}
        <Route path="/checkout-success" element={<CheckoutSuccessPage />} />


      </Routes>
    </Router>
  );
}

export default App;
